type SearchScope = {
   label: string,
   description?: string,
   translation?: string,
   query: any,
   params: string
}

const defaultScopeName: string = 'All'
const searchScopeTranslationPrefix = '(Search scope) '
// The scope builder (Customizer iframe) edits a scope from scratch, so no client scope may be applied there,
// even when 'All' is disabled and another scope would normally act as the default.
const scopeBuilderScope: SearchScope = { label: defaultScopeName, query: '', params: '' }

class SearchScopeService {
   searchScopes: SearchScope[]
   hasSearchScopes: boolean
   $log: angular.ILogService
   currentSearchScope?: SearchScope
   urlService: UrlService
   appState: AppStateService
   hooksService: HooksService
   viewState: ViewStateService
   fire: any
   on: any
   $uibModalInstance: any
   i18n: any
   warningMetaData: { fromAdvanced: boolean, scopeLabel: string, callBack?: (goBackToSearchScope: boolean, callbackDateParams?: any) => void, callbackDateParams?: any }
   constructor($log: angular.ILogService, config: ConfigService, urlService: UrlService, appState: AppStateService, i18n: TranslationService, hooksService: HooksService, viewState: ViewStateService) {
      this.$log = $log
      this.viewState = viewState
      this.i18n = i18n
      this.urlService = urlService
      this.hooksService = hooksService
      this.appState = appState
      this.searchScopes = config.data.search.searchScopes
      this.getSearchScopeByName = this.getSearchScopeByName.bind(this)
      this.getDefaultScope = this.getDefaultScope.bind(this)
      this.getSearchScopeTranslation = this.getSearchScopeTranslation.bind(this)
      this.searchScopes.forEach(s => {
         if (!s.translation) {
            s.translation = this.getSearchScopeTranslation(s.label)
         }
      })
      this.hasSearchScopes = config.data.search.hasSearchScopes
      this.currentSearchScope = this.getDefaultScope()
      hooksService.setHooks(this, 'SearchScopeService', ['clearScopeAsSideEffect'])
      // update the searchscopes from the application state
      this.appState.on('apply', () => this.syncWithAppState())
      this.warningMetaData = { fromAdvanced: false, scopeLabel: '' }
   }

   syncWithAppState() {
      this.currentSearchScope = this.getSearchScopeByName(this.appState?.params?.searchscope)
      if (this.currentSearchScope) {
         this.appState.parseSearchScopeFromUrlParams(this.currentSearchScope.query)
      }
   }

   getSearchScopeByName(scopeName: string): SearchScope {
      if (this.viewState?.scopeBuilderMode) {
         return scopeBuilderScope
      }
      if (scopeName) {
         return this.searchScopes.find(s => s.label === scopeName) || this.searchScopes.find(s => s.label === defaultScopeName) || this.searchScopes[0]
      }
      return this.searchScopes[0]   // set to the first searchScope (default scope) when ''.
   }

   getSearchScopeTranslation(textToTranslate: string): string {
      let translation = this.i18n.translate(searchScopeTranslationPrefix + textToTranslate)
      if (translation.includes(searchScopeTranslationPrefix)) {
         // we have no translation so use existing label
         translation = textToTranslate
      }
      return translation
   }
   getDefaultScope(): SearchScope {
      // In case 'All' is disabled, it will return the first item from the list.
      return this.getSearchScopeByName('All')
   }
   updateState(scope: SearchScope | undefined, updateState = true) {
      if (updateState && scope) {
         // modifying appstate params, but we won't do an actual search since we will wait on the user to hit search button
         if (scope?.params?.includes('PublicationDate') || scope?.query?.includes('PublicationDate')) { //keeps the query clean when a search scope has a PublicationDate, so the query is not polluted with rf=PublicationDate
            this.appState.params.rf = []
         }
         this.appState.params = angular.extend(this.appState.params, { searchscope: scope.label })
      }
   }

   getDefaultScopeName() {
      return defaultScopeName
   }

   updateStateByScopeName(scopeName: string) {
      const scope = this.getSearchScopeByName(scopeName)
      this.updateState(scope)
   }


   clearScopeAsSideEffect(advancedScopeName = '', callBack?: (goBackToSearchScope: boolean, callbackDateParams?: any) => void, callbackDateParams?: any) {
      const relevantScopeName = advancedScopeName || this.currentSearchScope?.label
      if (relevantScopeName && relevantScopeName !== defaultScopeName) {
         this.fire('clearScopeAsSideEffect', advancedScopeName, callBack, callbackDateParams)
      }
   }

   setDefaultScope() {
      this.appState.params = angular.extend(this.appState.params, { searchscope: defaultScopeName })
   }

   isDefaultScope(scopeName: string) {
      return scopeName === defaultScopeName
   }
}

SearchScopeService.$inject = ['$log', 'configService', 'urlService', 'appStateService', 'translationService', 'hooksService', 'viewStateService']

angular.module('summonApp.services')
   .service('searchScopeService', SearchScopeService)
